// extracted by mini-css-extract-plugin
export default {"settingHeader":"accordion_settingHeader__8LaM5","content":"accordion_content__nxpFG","arrowIconStyle":"accordion_arrowIconStyle__WWpUK"};